<script lang="ts" setup>
import { onMounted, ref, watch } from '#imports';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import iconRefresh from '~/assets/image/index/icon-refresh.svg';
import ModuleTitle from '../ModuleTitle.vue';
import ProblemItem from './ProblemItem.vue';
import { ProblemRecommendsService } from './ProblemRecommends.service';

declareProviders([ProblemRecommendsService]);
const service = useService(ProblemRecommendsService);

const activeKey = ref<number>();
const handleTabChange = (id: number) => {
  activeKey.value = id;
  if (service.problemsMap[id] === undefined) {
    service.getProblemRecommend(id);
  }
};
const getProblemRecommend = () => {
  service.getProblemRecommend(activeKey.value as number);
};
const getSpinningDelay = (itemId: number) => {
  // 如果是击换一换的方式，则加个延时，增加体验
  if (service.problemsMap[itemId]?.length > 0) {
    return 300;
  }
  return 0;
};
onMounted(() => {
  service.getRecommendSections();
});
watch(
  () => service.sections,
  (newSections) => {
    if (newSections.length === 0) return;
    const id = newSections[0].id as number;
    activeKey.value = id;
    service.getProblemRecommend(id);
  },
);
</script>
<template>
  <div
    v-if="!service.hasError"
    class="problem-recommends rounded border border-lightblack bg-white p-3"
  >
    <a-tabs v-model:active-key="activeKey">
      <a-tab-pane
        v-for="item in service.sections"
        :key="item.id"
        :tab="item.description"
      >
        <a-spin
          :delay="getSpinningDelay(item.id as number)"
          :spinning="service.loadingsMap[item.id as number]"
        >
          <div>
            <ul class="flex flex-wrap gap-3">
              <template v-if="service.problemsMap[item.id as number]">
                <li
                  v-for="(problem, index) in service.problemsMap[
                    item.id as number
                  ]"
                  :key="`${problem.pid}-${index}`"
                  v-track:newoj_homepage_problemrecommand_show="{
                    problem_id: problem.pid,
                  }"
                  v-track:newoj_homepage_problemrecommand_click.click="{
                    problem_id: problem.pid,
                  }"
                  class="w-[405px] shrink-0"
                >
                  <ProblemItem
                    :percent="problem.percent!"
                    :title="problem.title!"
                    :problem-id="problem.problemId!"
                    :difficulty="problem.difficulty!"
                    :owner-vo="problem.ownerVo!"
                    :like-count="problem.likeCount!"
                    :pid="problem.pid!"
                    :tags="problem.tags!"
                    :target="'blank'"
                  />
                </li>
              </template>
              <template v-else>
                <li
                  v-for="i in 10"
                  :key="i"
                  class="!h-[114px] w-[428px] shrink-0 overflow-hidden"
                >
                  <a-skeleton active :paragraph="{ rows: 5 }" class="" />
                </li>
              </template>
            </ul>
          </div>
        </a-spin>
      </a-tab-pane>
      <template #renderTabBar>
        <div
          class="mb-3 flex items-center justify-start"
        >
          <ModuleTitle class="mr-3">
            <img src="~/assets/image/index/title/tmtj.svg" alt="题目推荐" />
          </ModuleTitle>

          <a
            v-for="item in service.sections"
            :key="item.id"
            href="javascript:;"
            class="mr-4 flex h-[26px] items-center justify-center rounded-full border border-transparent px-2 py-1 text-center text-sm !text-colorText transition"
            :class="{ 'active-tab': activeKey === item.id }"
            @click="handleTabChange(item.id as number)"
          >
            {{ item.description }}</a
          >

          <a
            class="ml-auto flex items-center text-xs !text-colorTextSecondary"
            href="javascript:;"
            @click="getProblemRecommend"
          >
            换一批<img class="ml-1 w-[14px]" :src="iconRefresh" alt="换一批" />
          </a>
        </div>
      </template>
    </a-tabs>
  </div>
</template>
<style scoped>
.active-tab {
  @apply border-font1 font-bold;
}
</style>
